require "angular"

angular.module("workflow.app")
  .controller("AlertController", require "./AlertController")
